import type {StaticQueryDocument} from 'gatsby'
import {graphql, useStaticQuery} from 'gatsby'

import type {FormConsentQuery} from '@/graphql-types'
import {useConsentsLogic} from '@helios/shared/hooks/use-consents-logic'
import {useLocalizedContent} from '@helios/shared/hooks/use-localized-content'
import type {UseConsentsProps} from '@helios/shared/types/consents'

export const useConsents = (props: UseConsentsProps) => {
    const consents = useFormConsentsQuery(query)

    return useConsentsLogic({consents, ...props})
}

export const query = graphql`
    query FormConsent {
        allPrismicFormConsent {
            nodes {
                ...ConsentWebsite
            }
        }
    }
`

const useFormConsentsQuery = (query: StaticQueryDocument) => {
    const {allPrismicFormConsent} = useStaticQuery<FormConsentQuery>(query)

    return useLocalizedContent(allPrismicFormConsent.nodes).map(({data}) => ({
        ...data,
    }))
}
